import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { CompanyFollowStatus, SavedCompany } from "@/types/user/user.types";
import { Company } from "@/types/company";

export interface UpdateSavedCompanyViewCountData {
  saved_company_id: SavedCompany["id"];
}

export interface UpdateSavedCompanyViewCountResponse {
  success: boolean;
  message: string;
  saved_company: {
    id: SavedCompany["id"];
    company_name: Company["company_name"];
    view_count: SavedCompany["view_count"];
    last_viewed_at: SavedCompany["last_viewed_at"];
    company_follow_status: CompanyFollowStatus;
  };
}

export const useUpdateSavedCompanyViewCount = () => {
  const [data, setData] = useState<UpdateSavedCompanyViewCountResponse | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const updateSavedCompanyViewCount = async (
    formData: UpdateSavedCompanyViewCountData,
  ) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response =
        await axiosInstance.post<UpdateSavedCompanyViewCountResponse>(
          "users/users/update_saved_company_count/",
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

      setData(response.data);
      return response.data;
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, updateSavedCompanyViewCount };
};
